import VolumeControl from 'muvika-ios-volume-control';
import { Capacitor } from '@capacitor/core';
import navigationStore from '../stores/navigation';

class IosVolumeControl {

  async setDeviceVolume(level, isSetVolumeFlagFalse=false) {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      try {
        console.log("progChangeVolume", level)
        if(level!=0) navigationStore.getState().plusProgChangeVolume();
        await VolumeControl.setVolume({ volume: level });
        console.log("volume.js", `Volume set to ${level}`);
      } catch (error) {
        console.error('Error setting volume:', error);
      }
    }
  }

  async getDeviceVolume() {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      try {
        const { volume } = await VolumeControl.getVolume();
        console.log("volume.js", `Current volume: ${volume}`);
        return volume;
      } catch (error) {
        console.error('Error getting volume:', error);
      }
    }
  }

}

export default new IosVolumeControl();